import {svgIconWrapper} from '../svg-icon-wrapper';

import MightCallRegular from './might-call-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <MightCallRegular {...props} />;
}

SvgComponent.iconName = 'mightCallRegular';

export const MightCallRegularIcon = svgIconWrapper(SvgComponent);
